import { Button } from "../design/button";
import { Heading, Subheading } from "../design/heading";
import { useAuth } from "../contexts/AuthContext";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";

interface ErrorViewProps {
  error: Error;
}

const ErrorView: React.FC<ErrorViewProps> = ({ error }) => {
  const { user } = useAuth();

  const handleRetry = async () => {
    await user?.getIdToken(true);
    window.location.reload();
  };

  return (
    <div>
      <div className="flex items-center justify-center min-h-screen">
        <div className="flex flex-col items-center justify-center">
          <ExclamationTriangleIcon className="w-12 h-12 text-red-500" />
          <Heading className="mt-2">Error</Heading>
          <Subheading className="mt-2">{error.message}</Subheading>
          <Button className="mt-4" onClick={handleRetry}>
            Retry
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorView;
